import {type FunctionalComponent, h} from '@stencil/core';


export interface TabTitle {
    showTitle: boolean
    tabTitle: string
    showDocumentCount:boolean
    count: string | number

}

export const TabTitle: FunctionalComponent<TabTitle> = (props) => {

    const {showTitle, tabTitle, showDocumentCount, count} = props;

    return (
      showTitle && (
        <h2>
          {tabTitle}{' '}
          {showDocumentCount &&
                        ' (' + count + ')'}
        </h2>
      )
    );
};
